import { PageFooter, Corner } from "./chrome";

export default function VisionPage() {
  return (
    <section className="page" data-testid="page-vision">
      <div className="grain" />
      <Corner section="I · Doctrine" />
      <div className="page-inner">
        <div className="section-header">
          <div className="eyebrow">Vision · Mission · Values</div>
          <h2 className="h-title">
            Our aim is to <em>go green</em><br />and help nature thrive.
          </h2>
        </div>

        <div className="pillar-grid">
          <div className="pillar">
            <div className="marker">V</div>
            <h4>Vision</h4>
            <p>
              To deploy solar panels in every possible way — from mini-grid to ultra-mega grid-scale projects — and make the earth greener for the generations that will inherit it.
            </p>
          </div>
          <div className="pillar">
            <div className="marker">M</div>
            <h4>Mission</h4>
            <p>
              Equip and empower people to deploy solar power effectively, take charge of their energy costs and stay productive — at home, in commerce and in industry.
            </p>
          </div>
          <div className="pillar">
            <div className="marker">V</div>
            <h4>Values</h4>
            <p>
              Creativity, innovation and integrity are the core virtues we use to create and deliver substantial value to every stakeholder — customer, employee and community.
            </p>
          </div>
        </div>

        <div style={{ marginTop: 40, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
          <p className="body">
            <strong>3+ years of solar expertise.</strong> Our core competencies help customers take charge of their energy costs and stay competitive across Karnataka. A young, hungry team delivering measurable savings on every rooftop — and a meaningful contribution to a greener planet on every project.
          </p>
          <div style={{ borderLeft: "1px solid var(--line-2)", paddingLeft: 22 }}>
            <div className="eyebrow" style={{ marginBottom: 14 }}>Impact</div>
            <p className="body" style={{ margin: 0 }}>
              <strong>1 tonne of CO₂ avoided</strong> every year for every <strong>1 kW</strong> installed on a rooftop. With more than <strong>240+ active sites</strong>, our customers together avert thousands of tonnes of carbon emissions every year.
            </p>
          </div>
        </div>
      </div>
      <PageFooter num="05" />
    </section>
  );
}
